// This is a synchronous action, hence
// thunk will not interfere.
// These are using for Netwok Chart
import axios from "axios";
import Config from "../../config";
import { setErrorCode } from "./Workspace";
import { callNotification, errorCode, sessionExpired, getUTCOffset } from "../constants";
import { handleApiError, handleAxiosError } from "../utils/errorHandler";
export const resetNetwork = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_NETWORK", payload: null });
  };
};
export const setIsNetworkWidgetSettingEdit = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_IS_NETWORK_WIDGET_SETTING_EDIT", value: value });
  };
};
export const setNetworkWidgetSettingObject = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_NETWORK_WIDGET_SETTING_OBJECT", value: value });
  };
};

export const setNetworkDeepdiveLoader = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEPDIVE_LOADER", loader: value });
  };
};
export const setNetworkDeepdiveData = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEPDIVE_DATA", deepDiveData: value });
  };
};
export const getNetworkDeepdiveData = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    dispatch(setNetworkDeepdiveLoader(true));
    if (payloadObj?.body && payloadObj?.payload) {
      let body = payloadObj?.body
        ? {
            ...payloadObj?.body,
            widget_id: payloadObj?.widget_id,
            u_authorid: payloadObj?.u_authorid,
            utcoffset: getUTCOffset(),
          }
        : null;
      body.chart.chart_settings.chart_property.screen_width =
        window?.innerWidth;
      body.chart.chart_settings.chart_property.screen_height =
        window?.innerHeight;
      let url = payloadObj?.isCommandCenter
        ? payloadObj?.isUpdateImpression
          ? `${Config.config1.api_link}/command-center/chart?ignore_cache=True`
          : `${Config.config1.api_link}/command-center/chart`
        : payloadObj?.isUpdateImpression
        ? `${Config.config1.api_link}/widget-maker/${
            payloadObj?.data_source
              ? payloadObj?.data_source === "mentions"
                ? "chart"
                : payloadObj?.data_source + "-chart"
              : "chart"
          }?ignore_cache=True`
        : `${Config.config1.api_link}/widget-maker/${
            payloadObj?.data_source
              ? payloadObj?.data_source === "mentions"
                ? "chart"
                : payloadObj?.data_source + "-chart"
              : "chart"
          }`;

      // Custom error handlers for network deepdive API
      const customErrorHandlers = {
        4: (errorCodeValue, errorMessage, response, dispatch) => {
          // No data found - special handling
          dispatch(setNetworkDeepdiveData("No data found"));
          dispatch(setErrorCode(errorCodeValue));
        },
        9: (errorCodeValue, errorMessage, response, dispatch) => {
          // Session expired - use existing session management
          sessionExpired(true);
          dispatch(
            setNetworkDeepdiveData(response?.data?.reason || errorMessage)
          );
          dispatch(setErrorCode(errorCodeValue));
        },
        default: (errorCodeValue, errorMessage, response, dispatch) => {
          // Default error handling for other error codes including 21
          dispatch(
            setNetworkDeepdiveData(response?.data?.reason || errorMessage)
          );
          dispatch(setErrorCode(errorCodeValue));
        },
      };

      await axios
        .post(url, body)
        .then((response) => {
          let timer1,
            timer2 = null;
          // Disabled network deepdive  Loader
          dispatch(setNetworkDeepdiveLoader(false));
          if (response?.data?.status === "successful") {
            dispatch(setNetworkDeepdiveData(response?.data?.result));
          }
          if (response?.data?.status === "error") {
            dispatch(
              setNetworkDeepdiveData(
                response?.data?.error_code === 4
                  ? "No data found"
                  : response?.data?.reason
              )
            );
            dispatch(setErrorCode(response?.data?.error_code));
            handleApiError(response, dispatch, { customErrorHandlers });
          }
        })
        .catch((error) => {
          // Request aborted
          dispatch(setNetworkDeepdiveLoader(false));
          dispatch(setNetworkDeepdiveData(null));
          if (error.message !== "Request aborted") {
            handleAxiosError(error, dispatch, { customErrorHandlers });
          }
        });
    } else {
      dispatch(setNetworkDeepdiveLoader(false));
      dispatch(setNetworkDeepdiveData(null));
    }
  };
};

export const setNetworkAuthorPostDetailsLoader = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_AUTHOR_POST_DETAILS_LOADER", loader: value });
  };
};
export const setNetworkAuthorPostDetailsData = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_AUTHOR_POST_DETAILS_DATA",
      authorPostDetailsData: value,
    });
  };
};
export const getNetworkAuthorPostDetails = (payloadObj) => {
  let errorMessage;
  return async (dispatch) => {
    dispatch(setNetworkAuthorPostDetailsLoader(true));
    if (payloadObj?.body && payloadObj?.payload) {
      let body = payloadObj?.body
        ? {
            ...payloadObj?.body,
            widget_id: payloadObj?.widget_id,
            u_authorid: payloadObj?.u_authorid,
            utcoffset: getUTCOffset(),
          }
        : null;
      body.chart.chart_settings.chart_property.screen_width =
        window?.innerWidth;
      body.chart.chart_settings.chart_property.screen_height =
        window?.innerHeight;
      let url = payloadObj?.isCommandCenter
        ? payloadObj?.isUpdateImpression
          ? `${Config.config1.api_link}/command-center/chart?ignore_cache=True`
          : `${Config.config1.api_link}/command-center/chart`
        : payloadObj?.isUpdateImpression
        ? `${Config.config1.api_link}/widget-maker/${
            payloadObj?.data_source
              ? payloadObj?.data_source === "mentions"
                ? "chart"
                : payloadObj?.data_source + "-chart"
              : "chart"
          }?ignore_cache=True`
        : `${Config.config1.api_link}/widget-maker/${
            payloadObj?.data_source
              ? payloadObj?.data_source === "mentions"
                ? "chart"
                : payloadObj?.data_source + "-chart"
              : "chart"
          }`;

      // Custom error handlers for network author post details API
      const customErrorHandlers = {
        4: (errorCodeValue, errorMessage, response, dispatch) => {
          // No data found - special handling
          dispatch(setNetworkAuthorPostDetailsData("No data found"));
          dispatch(setErrorCode(errorCodeValue));
        },
        9: (errorCodeValue, errorMessage, response, dispatch) => {
          // Session expired - use existing session management
          sessionExpired(true);
          dispatch(
            setNetworkAuthorPostDetailsData(
              response?.data?.reason || errorMessage
            )
          );
          dispatch(setErrorCode(errorCodeValue));
        },
        default: (errorCodeValue, errorMessage, response, dispatch) => {
          // Default error handling for other error codes including 21
          dispatch(
            setNetworkAuthorPostDetailsData(
              response?.data?.reason || errorMessage
            )
          );
          dispatch(setErrorCode(errorCodeValue));
        },
      };

      await axios
        .post(url, body)
        .then((response) => {
          let timer1,
            timer2 = null;
          // Disabled network deepdive  Loader
          dispatch(setNetworkAuthorPostDetailsLoader(false));
          if (response?.data?.status === "successful") {
            dispatch(setNetworkAuthorPostDetailsData(response?.data?.result));
          }
          if (response?.data?.status === "error") {
            dispatch(
              setNetworkAuthorPostDetailsData(
                response?.data?.error_code === 4
                  ? "No data found"
                  : response?.data?.reason
              )
            );
            dispatch(setErrorCode(response?.data?.error_code));
            handleApiError(response, dispatch, { customErrorHandlers });
          }
        })
        .catch((error) => {
          // Request aborted
          dispatch(setNetworkAuthorPostDetailsLoader(false));
          dispatch(setNetworkAuthorPostDetailsData(null));
          if (error.message !== "Request aborted") {
            handleAxiosError(error, dispatch, { customErrorHandlers });
          }
        });
    } else {
      dispatch(setNetworkAuthorPostDetailsLoader(false));
      dispatch(setNetworkAuthorPostDetailsData(null));
    }
  };
};

export const setNetworkCommonEdgesColor = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_NETWORK_COMMON_EDGES_COLOR",
      commonEdgesColor: value,
    });
  };
};

export const setNetworkEdgesHighlightColor = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_NETWORK_HIGHLIGHT_EDGES_COLOR",
      edgesHighlightColor: value,
    });
  };
};
export const setDefaultColorSetIndexForNetwork = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DEFAULT_COLOR_SET_INDEX_FOR_NETWORK",
      defaultColorSetIndex: value,
    });
  };
};
